import * as yup from "yup";

export const OFFICE_PHONE_EDIT_FORM_SCHEMA = yup.object().shape({
  phoneNumber: yup.string().required("Molimo Vas da unesete telefon"),
});
